<template lang='pug'>
  i.svg-icon.svg-icon-bless
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )

      path(fill="#FEF4F4" d="M76.838,5.074H23.163c-8.933,0-16.173,7.241-16.173,16.173v35.205c0,8.933,7.241,16.174,16.173,16.174h7.703 c0.367,0,0.664,0.297,0.664,0.663v17.365c0,2.053,2.512,3.049,3.918,1.552l18.22-19.372c0.125-0.133,0.3-0.208,0.483-0.208h22.688 c8.933,0,16.174-7.242,16.174-16.174V21.247C93.012,12.315,85.771,5.074,76.838,5.074z")
      path(fill="#DBE5EA" d="M38.333,66.589c0-0.386-0.287-0.698-0.642-0.698h-7.458c-8.647,0-15.657-7.625-15.657-17.031V11.787 c0-1.591,0.201-3.132,0.577-4.593c-4.876,2.786-8.164,8.035-8.164,14.053v35.205c0,8.932,7.241,16.174,16.173,16.174h7.703 c0.367,0,0.664,0.297,0.664,0.663v17.365c0,2.053,2.512,3.049,3.918,1.552l2.886-3.067V66.589L38.333,66.589z")
      path(fill="#FEF4F4" d="M68.172,26.063L68.172,26.063c-4.105-4.106-10.763-4.106-14.869,0l-2.319,2.319 c-0.553,0.553-1.451,0.553-2.003,0L46.697,26.1c-4.106-4.106-10.764-4.106-14.87,0l0,0c-4.106,4.106-4.106,10.764,0,14.871 l17.154,17.154c0.553,0.553,1.45,0.553,2.002,0l17.188-17.191C72.278,36.828,72.278,30.17,68.172,26.063z")
      path(fill="#DE5466" d="M68.172,26.063L68.172,26.063c-4.105-4.106-10.763-4.106-14.869,0l-2.319,2.319 c-0.553,0.553-1.451,0.553-2.003,0L46.697,26.1c-4.106-4.106-10.764-4.106-14.87,0l0,0c-4.106,4.106-4.106,10.764,0,14.871 l17.154,17.154c0.553,0.553,1.45,0.553,2.002,0l17.188-17.191C72.278,36.828,72.278,30.17,68.172,26.063z")
      path(fill="#D83B4E" d="M37.328,40.971c-4.106-4.106-4.106-10.764,0-14.871l0,0c1.347-1.347,2.969-2.249,4.685-2.712 c-3.515-0.949-7.426-0.047-10.185,2.712l0,0c-4.106,4.106-4.106,10.764,0,14.871l17.154,17.154c0.553,0.553,1.45,0.553,2.003,0 l1.749-1.749L37.328,40.971z")

</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },

}
</script>